import { render, staticRenderFns } from "./ModalSimple.vue?vue&type=template&id=8fa6a38a&"
import script from "./ModalSimple.vue?vue&type=script&lang=js&"
export * from "./ModalSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports